import { useCallback, useEffect, useRef, useState } from "react";

/** Debounced search for an async multi-entity options hook. */
export function useDebouncedSearch(delayMs = 300): {
  query: string;
  onSearch: (value: string) => void;
} {
  const [query, setQuery] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const onSearch = useCallback(
    (value: string) => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setQuery(value.trim()), delayMs);
    },
    [delayMs],
  );

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  return { query, onSearch };
}
